import React from "react";
import {useTranslation} from "react-i18next";
import QButton from "../../../../common/components/QButton";

interface Props {
    loading?: boolean;
    onRetry: () => void;
}

const SetupOptionsError: React.FC<Props> = ({loading, onRetry}) => {
    const {t} = useTranslation();

    return (
        <div className="alert alert-warning d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2 mb-3">
            <div>
                <strong className="d-block">{t("common.setup.optionsLoadFailed")}</strong>
                <span className="small">{t("common.setup.optionsLoadFailedHelp")}</span>
            </div>
            <QButton
                type="default"
                className="btn-sm"
                disabled={loading}
                onClick={onRetry}
                content={loading ? t("common.setup.retrying") : t("common.setup.retry")}
            />
        </div>
    );
};

export default React.memo(SetupOptionsError);
